import {Badge, Icon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export const MasavTransferBadge: FC = () => {
  const {t} = useTranslation('trustAccounts');

  return (
    <Badge variant="neutral" size="sm">
      <Icon name="clock" className="size-3" />
      {t('view.instructions.transferTypes.masav')}
    </Badge>
  );
};
